import { z } from 'zod';
import { platformSchema } from './common';
import { semverSchema } from './version';

export const expoPushTokenSchema = z
  .string()
  .regex(/^Expo(nent)?PushToken\[[^\]]+\]$/, 'Invalid Expo push token');

/** POST /api/v1/devices; DELETE /api/v1/devices/{expoPushToken} (brief §5.3). */
export const registerDeviceSchema = z.object({
  expoPushToken: expoPushTokenSchema,
  platform: platformSchema.exclude(['web']),
  appVersion: semverSchema,
});
export type RegisterDevice = z.infer<typeof registerDeviceSchema>;
